import { render, staticRenderFns } from "./SlackChannel.vue?vue&type=template&id=55c49072&scoped=true&"
import script from "./SlackChannel.vue?vue&type=script&lang=js&"
export * from "./SlackChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c49072",
  null
  
)

export default component.exports